<template>
    <div :style="{ '--upload-width': width + 'px', '--upload-height': height + 'px', height: height + 'px' }">
        <a-upload :action="action" list-type="picture-card" :headers="header" :file-list="fileList"
            @preview="handlePreview" @change="handleChange" :accept="accept">
            <div v-if="fileList.length < size">
                <a-icon type="plus" />
                <div class="ant-upload-text">上传图片</div>
            </div>
        </a-upload>
        <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
            <img alt="example" style="width: 100%" :src="previewImage" />
        </a-modal>
    </div>
</template>

<script>
import { getUploadUrl, getHeader } from '@/config/request';
import utils from '@/common/utils.js';

function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

export default {
    name: 'UploadImages',
    props: {
        value: {
            type: Array,
            default: () => []
        },
        size: {
            type: Number,
            default: 3
        },
        width: {
            type: Number,
            default: 90
        },
        height: {
            type: Number,
            default: 90
        }
    },
    data() {
        return {
            accept: 'image/*',
            action: getUploadUrl(),
            header: getHeader(),
            previewVisible: false,
            previewImage: '',
            fileList: []
        };
    },
    watch: {
        value: {
            handler(val) {
                if (Array.isArray(val) && val.length > 0) {
                    const arr = val
                        .filter(url => url)
                        .map(url => ({
                            uid: utils.md5(url),
                            name: utils.md5(url),
                            status: 'done',
                            url: url
                        }));
                    this.fileList = arr;
                } else {
                    this.fileList = [];
                }
            },
            deep: true,
            immediate: true
        },
        fileList: {
            handler(val) {
                let result = [];
                val.forEach(item => {
                    if (item.status === 'done' && (item.url || item.response?.data)) {
                        result.push(item.url || item.response.data);
                    }
                });
                // 防止不必要的 emit 导致父组件频繁更新
                const currentVal = JSON.stringify(this.value);
                const nextVal = JSON.stringify(result);
                if (currentVal !== nextVal) {
                    this.$emit('input', result);
                    // console.log('emit', result);
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        handleCancel() {
            this.previewVisible = false;
        },
        async handlePreview(file) {
            if (!file.url && !file.preview) {
                file.preview = await getBase64(file.originFileObj);
            }
            this.previewImage = file.url || file.preview;
            this.previewVisible = true;
        },
        handleChange({ file, fileList }) {
            this.fileList = fileList;
        }
    }
};
</script>

<style>
/* you can make up upload button and sample style by using stylesheets */
.ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
}

/* .ant-upload-list-picture-card-container,
.ant-upload-select-picture-card {
    border: 1px solid #f00 !important;
    width: 90px !important;
    height: 90px !important;
}

.ant-upload-list-item {
    border: 1px solid #f00 !important;
    width: 90px !important;
    height: 90px !important;
} */

.ant-upload-list-picture-card-container,
.ant-upload-select-picture-card,
.ant-upload-list-item {
    width: var(--upload-width) !important;
    height: var(--upload-height) !important;
    /* border: 1px solid #f00 !important; */
    /* overflow: hidden; */
}
</style>